export function formatSsn(ssn) {
  if (!ssn) return '';

  // Remove non-digit characters
  ssn = ssn.replace(/[^\d]/g, '');

  // Limit the SSN to 9 digits
  if (ssn.length > 9) {
    ssn = ssn.substr(0, 9);
  }

  // Format as XXX-XX-XXXX
  return ssn.replace(/^(\d{0,3})(\d{0,2})?(\d{0,4})?$/, function (_, x, y, z) {
    return [x, y, z].filter(Boolean).join('-');
  });
}
//# sourceMappingURL=ssnValidationUtil.js.map
